import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { ErrorCode, ErrorInfo } from "@/network/http";
import { AreaInfo } from '@/data/local/common'
import { getAllAreas } from "@/service/common";
import store from '@/store'

export interface CommonState {
    allAreas: AreaInfo[]; //地区信息
}

const KEY_AREA = "areaInfo";

@Module({ name: 'common', namespaced: true, dynamic: true, store })
export default class Common extends VuexModule {
    public commonState: CommonState = {
        allAreas: []
    };
    
    get getAreas(): AreaInfo[] {
        if (this.commonState.allAreas === null || this.commonState.allAreas.length === 0) {
            //store中没有数据时取缓存
            let localAreas = localStorage.getItem(KEY_AREA);
            if (localAreas) {
                this.commonState.allAreas = JSON.parse(localAreas);
            }
        }

        return this.commonState.allAreas;
    }

    @Mutation
    private updateAllAreas(allAreas: AreaInfo[]) {
        this.commonState.allAreas = allAreas;
    }

    @Action
    public fetchAreas() {
        getAllAreas((errorInfo: ErrorInfo, data: AreaInfo[]) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                //失败不做处理
            } else {
                //缓存
                localStorage.setItem(KEY_AREA, JSON.stringify(data));
                this.context.commit("updateAllAreas", data);
            }
        });
    }
}